export const queryKeys = {
  FLAT_MORE_LIST: 'FLAT_MORE_LIST'
};
